// src/modals/AskTendUpgrade.jsx
// Phase 37 Plan 06 — extracted from src/App.jsx (was lines 9027-9061 pre-Plan-37-06).
//
// Open Question 2 resolved: lives in src/modals/, NOT src/views/ask-tend/.
// It's a free-tier upgrade prompt shown in place of the AskTend chat — modal-shaped
// presentational component with no chat logic of its own.
//
// Scope: FF-01 — free-tier upgrade prompt for Ask Tend. Renders the "Meet Ask Tend"
// pitch with three bullet points and the Discover Premium CTA.

import { MessageCircle, Sparkles, Leaf, CalendarDays } from 'lucide-react';

export default function AskTendUpgrade({onShowPremium}) {
  const bullets = [
    {icon:Sparkles,     text:"Personalised advice for your exact garden"},
    {icon:Leaf,         text:"Add plants by simply describing them"},
    {icon:CalendarDays, text:"Month-by-month care schedules from AI"},
  ];
  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center",minHeight:400,padding:24}}>
      <div style={{maxWidth:480,width:"100%",margin:"0 auto",background:"var(--c-bg)",borderRadius:20,padding:"36px 32px",boxShadow:"0 4px 24px rgba(0,0,0,0.08)",textAlign:"center"}}>
        <MessageCircle size={48} color="var(--c-heading)" style={{marginBottom:16}}/>
        <h2 style={{fontFamily:"var(--font-family-display)",color:"var(--c-heading)",margin:"0 0 14px",fontSize:'var(--font-h1)'}}>Meet Ask Tend</h2>
        <p style={{fontFamily:"var(--font-family-body)",fontSize:'var(--font-body)',lineHeight:1.7,color:"var(--c-text-2)",margin:"0 0 24px"}}>
          Your personal garden expert who knows every plant in your garden. Ask anything — what to prune this month, how to care for your roses, or add new plants just by chatting.
        </p>
        <div style={{display:"flex",flexDirection:"column",gap:12,margin:"0 0 28px",textAlign:"left"}}>
          {bullets.map(({icon:Icon,text})=>(
            <div key={text} style={{display:"flex",alignItems:"center",gap:12,padding:"10px 14px",background:"var(--c-blight)",borderRadius:12}}>
              <Icon size={18} color="var(--c-heading)" className="shrink-0"/>
              <span style={{fontSize:'var(--font-body)',color:"var(--c-text)",fontFamily:"var(--font-family-body)"}}>{text}</span>
            </div>
          ))}
        </div>
        <button onClick={onShowPremium}
          style={{background:"var(--c-heading)",color:"#fff",border:"none",borderRadius:24,padding:"12px 28px",fontSize:'var(--font-body)',fontWeight:700,cursor:"pointer",width:"100%",marginBottom:12}}>
          Discover Premium
        </button>
        <p style={{fontSize:'var(--font-tiny)',color:"var(--c-text-3)",margin:0}}>Free plan includes full plant management, scheduling, and more</p>
      </div>
    </div>
  );
}
